import { useState, FunctionComponent, useEffect, useCallback } from 'react';

// Libs
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { stringify } from 'query-string';

// Components
import Image from '@Components/Utils/Image';

// GA
import { trackingEvent } from '@Components/Utils/Lazy/Script';

// Utils
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import styles from './PopularCard.module.scss';

interface PopularCardProps {
    tags?: any;
    listsTags?: any;
    className?: string;
    onclose?: () => void;
    disableTitle?: boolean;
}

export const getQueryPopular = (query: any) => {
    if (!query) return [];

    if (Array.isArray(query)) return query;

    return [query];
};

const PopularCard: FunctionComponent<PopularCardProps> = ({ onclose, className, disableTitle, listsTags, tags }) => {
    const { push, query } = useRouter();
    // const { listsTags, tags } = useNewsFeed();

    const [listFilter, setListFilter] = useState<any>(tags);

    useEffect(() => {
        if (JSON.stringify(listFilter) !== JSON.stringify(tags)) {
            setListFilter(tags);
        }
    }, [tags]);

    const { deviceType } = useViewDetected();
    const isMobile = deviceType !== 'desktop';

    const newQuery = { ...query };
    delete newQuery['pho_bien'];

    const handleCloseFilter = useCallback(() => {
        setTimeout(() => {
            if (JSON.stringify(listFilter) !== JSON.stringify(tags)) {
                setListFilter(tags);
            }
            onclose();
        }, 300);
    }, [listFilter, onclose]);

    const clearFilter = () => {
        setListFilter([]);
    };

    const getNewQueryPrams = useCallback(
        (slug: string) => {
            let newData;
            if (!listFilter?.includes(slug)) {
                newData = [...listFilter, slug];
                setListFilter(newData);
            } else {
                newData = listFilter.filter((f) => f !== slug);
                setListFilter(newData);
            }

            // event tracking
            trackingEvent('nhấp vào các tag', 'Mục phổ biến', newData);

            if (!isMobile) {
                setTimeout(() => {
                    pushRouterDesktop(newData);
                }, 300);
            }
        },
        [listFilter],
    );

    const pushRouterDesktop = (newData) => {
        const newQueryParams = stringify({ ...newQuery, pho_bien: newData }, { skipEmptyString: true });
        newQueryParams?.length > 0 ? push(`/hoi-dap?${newQueryParams}`) : push('/hoi-dap');
    };

    // Mobi
    const pushRouter = () => {
        const newQueryParams = stringify({ ...newQuery, pho_bien: listFilter }, { skipEmptyString: true });
        newQueryParams?.length > 0 ? push(`/hoi-dap?${newQueryParams}`) : push('/hoi-dap');
        onclose();
    };

    const CheckActive = (slug: string) => {
        return listFilter?.includes(slug);
    };

    const renderPopularItem = () => {
        return listsTags?.map(({ title, slug }, index) => {
            const popularClassName = classNames([styles.popular, { [styles.active]: CheckActive(slug) }]);
            return (
                <span className={popularClassName} key={`${title}-${index}`} onClick={() => getNewQueryPrams(slug)}>
                    {title}
                </span>
            );
        });
    };

    const wrapperClassName = classNames([styles.wrapper, { [styles.mobile]: isMobile }, className]);
    return (
        <div className={wrapperClassName}>
            <ViewMedia is={['mobile', 'tablet']}>
                <div className={styles.filter_header}>
                    <Image
                        width={24}
                        height={24}
                        className={styles.close}
                        onClick={handleCloseFilter}
                        src="/assets/icon_close.png"
                    />
                    Bộ lọc
                    <span className={styles.clear} onClick={clearFilter}>
                        Thiết lập lại
                    </span>
                </div>
            </ViewMedia>

            <div className={styles.filter_option}>
                {!disableTitle && <div className={styles.title}>Mục phổ biến</div>}
                <div className={styles.popular_wrapper}>{renderPopularItem()}</div>
            </div>

            <ViewMedia is={['mobile', 'tablet']}>
                <div className={styles.filter_footer}>
                    <button className={styles.btn} onClick={pushRouter}>
                        Xác nhận
                    </button>
                </div>
            </ViewMedia>
        </div>
    );
};

PopularCard.defaultProps = {
    className: '',
    disableTitle: false,
};

export default PopularCard;
